import { LoadAuthorizedCommunicationHistory } from 'domain/usecases/surgical-pendency/load-authorized-communication-history'
import { SurgicalPendencyRepository } from 'repository/repositories/surgical-pendency/surgical-pendency-repository'

export class RemoteLoadAuthorizedCommunicationHistory
  implements LoadAuthorizedCommunicationHistory
{
  constructor(
    private readonly surgicalPendencyRepository: SurgicalPendencyRepository
  ) {}

  load(
    params: LoadAuthorizedCommunicationHistory.Params
  ): Promise<LoadAuthorizedCommunicationHistory.Model> {
    return this.surgicalPendencyRepository.loadAuthorizedCommunicationHistory(
      params
    )
  }
}
